import { API } from '../../utils';
import { ITicket } from '../../types';
import { GW_SERVICES_PREFIXES } from 'constants/gateway';

const { C300 } = GW_SERVICES_PREFIXES;

export const CreateTicket = (data: ITicket) =>
  API.gatewayPost(`/${C300}/models/tenant_tickets/`, data);
